import { useState } from "react";
import { useSingleBusinessVerification } from "../../../../composables/business-merchant/verification/useSingleBusinessVerification";
import { useApi } from "../../../../providers/ApiProvider";
import DefaultModal from "../../../../components/modal/default-modal";
import Button from "../../../../components/form/button";
import ImagePreviewer from "../../../../components/ui/image-previewer";
import FlagReasonModal from "./flag-reason-modal";

const StatusReportVerification = ({ open, code, onClose, verified }: { open: boolean, code: string, onClose?: () => void, verified: boolean }) => {
    const [openImage, setOpenImage] = useState(false);
    const { data } = useSingleBusinessVerification({
        type: 'status_report',
        enabled: open && !!code,
        code,
    });

    const api = useApi();

    const [openFlag, setOpenFlag] = useState(false);

    const approval = async (flagReason?: string) => {
        const status = flagReason ? 'rejected' : 'approved';
        const res = await api.POST({
            endpoint: `business-merchant/${code}/documentation/approval`,
            payload: {
                type: 'status_report',
                status,
                flagged_reason: flagReason,
            },
            refreshKeys: [
                ['business-merchant', 'documentation', code],
            ],
        });

        if (!res) return;
        setOpenFlag(false);
        onClose && onClose();
    }

    return (
        <div className="space-y-6">
            <FlagReasonModal
                open={openFlag}
                onClose={() => setOpenFlag(false)}
                submitReason={approval}
                submitting={api.postLoading}
            />
            <div>
                <Button onClick={() => setOpenImage(true)} design="primary-outline" text="View Document" />
                <ImagePreviewer open={openImage} onClose={() => setOpenImage(false)} image={data?.url} />
            </div>
            {!verified && (
                <div className="flex gap-4 flex-wrap">
                    <DefaultModal
                        onConfirmationAction={() => approval()}
                        modalButtonTriggerText={<Button text="Approve" />}
                        description="Are you sure you want to approve the supplied information?"
                    />
                    <Button onClick={() => setOpenFlag(true)} text="Flag an issue" design="primary-danger-outline" />
                </div>
            )}
        </div>
    )
}

export default StatusReportVerification